/**
 * 轉蛋抽獎列的單次抽數上限與按鈕狀態。規則與首屏渲染的 GachaDrawLimits::cap()
 * （gacha-draw-bar.php）相同：上限 = min(drawMax, 限量剩餘配額, 每日限購剩餘)。
 * DOM 留給呼叫端，這裡只算。
 */

function toLimit(value) {
    if (value === null || value === undefined || value === '') {
        return null;
    }
    return Number(value);
}

/** 同 GachaDrawLimits::cap()：null = 該限制不適用；字串數字會先轉數字；下限 0 */
export function drawLimitCap({ drawMax, quotaRemaining, dailyRemaining }) {
    const limits = [drawMax, quotaRemaining, dailyRemaining]
        .map(toLimit)
        .filter((v) => v !== null);

    return Math.max(0, Math.min(...limits));
}

/**
 * 抽數超過上限的組合鈕停用；自訂數量上限至少 1；上限 ≤ 0 時自訂抽停用。
 * blocked（未登入、套利異常、已下架）時全部停用。
 *
 * @returns {{ bundleDisabled: Record<number, boolean>, qtyMax: number, customDisabled: boolean }}
 */
export function drawBarControls({ drawMax, quotaRemaining, dailyRemaining, blocked, bundles }) {
    const cap = drawLimitCap({ drawMax, quotaRemaining, dailyRemaining });
    const bundleDisabled = {};
    for (const n of bundles) {
        bundleDisabled[n] = blocked || n > cap;
    }

    return {
        bundleDisabled,
        qtyMax: Math.max(1, cap),
        customDisabled: blocked || cap <= 0,
    };
}

/** 讀 .wgp-draw-bar 的 dataset（limitQuota / limitDaily / limitBlocked）→ 頁面初始限制狀態 */
export function readLimitState(dataset) {
    return {
        quotaRemaining: toLimit(dataset.limitQuota),
        dailyRemaining: toLimit(dataset.limitDaily),
        blocked: dataset.limitBlocked === '1',
    };
}
